import { FC } from "react";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import MuiCheckbox from "@mui/material/Checkbox";
import styled from "styled-components";

interface ICheckboxProps {
  label: string;
  name: string;
  value?: boolean;
  defaultValue?: boolean;
  errorMessage?: string;
  type?: string;
  required?: boolean;
  errors?: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: FC<ICheckboxProps> = ({
  name,
  label,
  value,
  errorMessage,
  onChange,
  errors,
}) => {
  return (
    <FormControl>
      <FormControlLabel
        control={
          <MuiCheckbox
            name={name}
            checked={value}
            size="small"
            onChange={onChange}
            // required={required}
          />
        }
        label={label}
      />
      {errors && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </FormControl>
  );
};

export default Checkbox;

const ErrorMessage = styled.span`
  color: #d32f2f;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 3px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
`;
